
import Vue from 'vue';
import { Component, Prop, ProvideReactive } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { Platform } from '@/@types/graphql-types';
import { SingleStepContext } from '@/helpers/sports/config';
import {
	GetSportProvidersByShortNamesDocument,
	GetSportProvidersByShortNamesQuery,
	GetSportProvidersByShortNamesQueryVariables,
} from '@/pages/graphql/queries/GetSportProvidersByShortNames.query';

import SportsFooter from '@/components/sports/common/SportsFooter.vue';
import TimeZoneSwitcher from '@/components/sports/common/TimeZoneSwitcher.vue';

const Language = namespace('language');

@Component({
	name: 'SportsLayout',
	components: {
		SportsFooter,
		TimeZoneSwitcher,
	},
	apollo: {
		sportProvidersByShortName: {
			query: GetSportProvidersByShortNamesDocument,
			variables(): GetSportProvidersByShortNamesQueryVariables {
				return this.queryVariables;
			},
			update(data: GetSportProvidersByShortNamesQuery) {
				return data.packages;
			},
			skip() {
				return !this.$route.name?.startsWith('app.sports');
			},
		},
	},
})
export default class SportsLayout extends Vue {
	@Prop({ required: true }) context: SingleStepContext;

	@Language.Getter country: string;

	@ProvideReactive('sportProvidersByShortName')
	sportProvidersByShortName: GetSportProvidersByShortNamesQuery['packages'] = [];

	get queryVariables(): GetSportProvidersByShortNamesQueryVariables {
		return {
			country: this.country,
			platform: Platform.Web,
		};
	}
}
